import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=288607cc&scoped=true&lang=pug"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"
import style0 from "./resources.vue?vue&type=style&index=0&id=288607cc&prod&lang=scss&scoped=true"
import style1 from "./resources.vue?vue&type=style&index=1&id=288607cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288607cc",
  null
  
)

export default component.exports